import { render, staticRenderFns } from "./AccountSetting.vue?vue&type=template&id=ec95315c&"
import script from "./AccountSetting.vue?vue&type=script&lang=js&"
export * from "./AccountSetting.vue?vue&type=script&lang=js&"
import style0 from "./AccountSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports